export default "__VITE_ASSET__C5R5DeaQ__"